type EnvironmentVariables = {
  BUILD_ID?: string;
  ENVIRONMENT_NAME?: string;
  ENABLE_ACCESSIBILITY_CHECKS?: boolean;
  FASTLY_ALL_PAGES_CACHE_KEY?: string;
  DATADOG_CLIENT_TOKEN?: string;
  ENABLE_DATADOG?: boolean;
  ENABLE_SENTRY?: boolean;
  SENTRY_DSN?: string;
  ENABLE_HEAP?: boolean;
  HEAP_APP_ID?: string;
  POS_API_ENDPOINT?: string;
  CLOVER_PAYMENT_FORM_URL?: string;
  CLOVER_PLATFORM_PUBLIC_KEY?: string;
  ENABLE_BENTO_STREAM?: boolean;
  ENABLE_SMARTLOOK?: string;
  SMARTLOOK_PROJECT_KEY?: string;
};

const getEnvironmentVariables = (): EnvironmentVariables => ({
  BUILD_ID: process.env.BUILD_ID,
  ENVIRONMENT_NAME: process.env.ENVIRONMENT_NAME,
  ENABLE_ACCESSIBILITY_CHECKS:
    String(process.env.ENABLE_ACCESSIBILITY_CHECKS) === 'true',
  FASTLY_ALL_PAGES_CACHE_KEY: process.env.FASTLY_ALL_PAGES_CACHE_KEY,
  DATADOG_CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN,
  ENABLE_DATADOG: String(process.env.ENABLE_DATADOG) === 'true',
  ENABLE_SENTRY: String(process.env.ENABLE_SENTRY) === 'true',
  SENTRY_DSN: process.env.SENTRY_DSN,
  ENABLE_HEAP: String(process.env.ENABLE_HEAP) === 'true',
  HEAP_APP_ID: process.env.HEAP_APP_ID,
  POS_API_ENDPOINT: process.env.POS_API_ENDPOINT,
  CLOVER_PAYMENT_FORM_URL: process.env.CLOVER_PAYMENT_FORM_URL,
  CLOVER_PLATFORM_PUBLIC_KEY: process.env.CLOVER_PLATFORM_PUBLIC_KEY,
  ENABLE_BENTO_STREAM: String(process.env.ENABLE_BENTO_STREAM) === 'true',
  ENABLE_SMARTLOOK: process.env.ENABLE_SMARTLOOK,
  SMARTLOOK_PROJECT_KEY: process.env.SMARTLOOK_PROJECT_KEY
});

export default getEnvironmentVariables;
